import { FooterDataDto } from '@asset-metrix/portal-gateway-client-js';
import { AG_GRID_GROUP_AUTO_COLUMN_ID } from '@asset-metrix/portal-ui';
import { IAggFuncParams, IRowNode } from 'ag-grid-community';

function getGroupDataValues(rowNode: IRowNode<unknown>): (string | number)[] {
  let value = rowNode.groupData?.[AG_GRID_GROUP_AUTO_COLUMN_ID];

  // Temp handling "null" as a key use case in the group footer api eg: {"2019": 1234, "null": 5678}
  // TODO: Align with BE team to fix this special case handling in portal API
  if (rowNode.key === '') {
    value = 'null';
  }

  if (value == null) {
    return [];
  }
  if (rowNode.parent == null) {
    return [value];
  }
  return [...getGroupDataValues(rowNode.parent), value];
}

export const getGroupFooterAggregationFunc = (
  groupFooter: FooterDataDto['groupFooter']
) => {
  return ({ colDef, rowNode }: IAggFuncParams) => {
    if (!colDef.field) {
      return;
    }

    const data = groupFooter?.[colDef.field];
    if (!data) {
      return;
    }

    const groupDataValues = getGroupDataValues(rowNode);
    let grouped = data?.grouped;
    let total;
    // Find the total value from the nested group data keys
    for (const key of groupDataValues) {
      let footerGroupData = grouped?.[key];

      // Same temp fix as above for 'null' values, but for numbers. In the row data they are of type number, but since they are used as object keys in the group footer response, they are strings there.
      // Since it's not possible to stringify the number in the correct way, because of the arbitrary precision, we need to parse the string as a number
      if (footerGroupData == null && typeof key === 'number') {
        const stringifiedNumberKey = Object.keys(grouped ?? {}).find(
          (k) => Number.parseFloat(k) === key
        );

        if (stringifiedNumberKey) {
          footerGroupData = grouped?.[stringifiedNumberKey];
        }
      }

      if (key === groupDataValues.at(-1)) {
        total = footerGroupData?.total;
      }
      grouped = footerGroupData?.grouped;
    }

    return total;
  };
};
